import Logo from "../logo";
import { MobilePalms } from "../palms";
import shared from "../../data/js/shared";

const {
	moreInfoHeading,
	twoFactorHeading1,
	twoFactorHeading2,
	verifyHeading1,
	verifyHeading1b,
	verifyHeading2,
	verifySub,
	verifySub2,
	loginHeading,
	loginSubHeading,
	loginWord,
	signupWord,
} = shared.login;

export interface LoginHeaderProps {
	loginView: string;
}

/**
 * LoginHeader Component
 *
 * Renders the animated header section with different content based on login view state
 *
 * @param loginView - Current login view state
 */
export const LoginHeader = ({ loginView: _loginView }: LoginHeaderProps) => {
	return (
		<>
			<h2 className="login-heading">
				<Logo className="mobile-switcheroo" />
				<div className="mask-box mask-box1">
					<div className="word top-word">{loginWord}</div>
					<div className="word bottom-word">{signupWord}</div>
				</div>
				<div className="heading-continuation">{loginHeading}</div>
			</h2>
			<p className="login-subheading text-center">{loginSubHeading}</p>
			<MobilePalms />
			<h2 className="two-factor-heading">
				<div className="mask-box mask-box2">
					<div className="word top-word">{twoFactorHeading1}</div>
					<div className="word text-word bottom-word">
						{verifyHeading1}
					</div>
					<div className="word email-word bottom-word">
						{verifyHeading1b}
					</div>
				</div>
				<div className="mask-box mask-box2">
					<div className="word top-word">{twoFactorHeading2}</div>
					<div className="word bottom-word">{verifyHeading2}</div>
				</div>
			</h2>
			<div className="two-factor-sub">
				{verifySub}
				<br />
				{verifySub2}
			</div>
			<h2 className="more-info-heading">{moreInfoHeading}</h2>
		</>
	);
};
